export default {
  presenter: 'pluskal',
  title: 'Instalace a uzivani openSUSE',
  subtitle: 'začátečníci',
  text: `
Instalace a zaklady uzivani openSUSE pro zacatecniky a mirne pokrocile, specifika openSUSE/SUSE.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/pluskal-opensuse.js